export default "__VITE_ASSET__C_aX1GJd__"